// Handles opening/closing the newsletter form when any
// `.toggle-newsletter` control is clicked. Uses jQuery delegation
// for broad browser compatibility and to work across Turbolinks navigations.

const bindNewsletterToggle = () => {
  if (!window.jQuery) return;
  const $ = window.jQuery;

  $(document).off('click.newsletterToggle', '.toggle-newsletter');
  $(document).on('click.newsletterToggle', '.toggle-newsletter', function (e) {
    e.preventDefault();
    const $signup = $('.newsletter-signup');
    if ($signup.length === 0) return;

    $signup.toggleClass('opened');

    var $visitWidget = $('#visit_widget_button');
    if ($visitWidget.length) {
      $visitWidget.toggle(!$signup.hasClass('opened'));
    }
  });
};

document.addEventListener('turbolinks:load', bindNewsletterToggle);
document.addEventListener('DOMContentLoaded', bindNewsletterToggle);

export default bindNewsletterToggle;
